export default __webpack_public_path__ + "static/media/ig11.216cdb94.webp";